var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlutter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6193 28.6998L30.6982 48.6836L36.6933 64.5599L105.491 38.581L83.6193 28.6998Z",
    fill: "#40C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.669 71.3883L61.5624 82.3793L55.5673 66.503L68.7976 61.507L90.669 71.3883Z",
    fill: "#40C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5655 66.5027L39.6898 72.4979L45.685 88.3736L61.5607 82.3784L55.5655 66.5027Z",
    fill: "#03A9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5534 111.486L50.6819 101.605L45.686 88.3744L61.5623 82.3793L72.5534 111.486Z",
    fill: "#01579B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.686 88.3744L64.5599 90.3175L61.5623 82.3793L45.686 88.3744Z",
    fill: "#084994"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(39.5249) rotate(24.3128)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.626481fce944c8e52088e6695052a566.svg";
export { ForwardRef as ReactComponent };